export default "__VITE_ASSET__BkvMH_BH__"